import { forwardRef, type Ref, type SVGProps } from "react";
const IconRestaurantFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M8.39 3.506a.536.536 0 0 1 1.07-.015l.438 5.261a.27.27 0 0 0 .539-.003l.446-6.25a.535.535 0 0 1 .906-.35.52.52 0 0 1 .165.35l.447 6.25a.27.27 0 0 0 .348.24.27.27 0 0 0 .19-.237l.439-5.26a.536.536 0 0 1 1.069.014l.386 6.95a3 3 0 0 1-1.121 2.51c-.79.631-.793.98-.793 1.995V28.5a1.5 1.5 0 1 1-3 0V14.961c0-1.015-.004-1.364-.793-1.995a3 3 0 0 1-1.121-2.51z" />
    <path d="M21.919 14.838c.003-.57.032-1.142.368-1.334 1.542-.881 2.438-2.651 2.261-4.42C24.241 6.015 23.632 2 20.419 2s-3.822 4.015-4.13 7.085c-.176 1.768.72 3.538 2.262 4.419.368.21.368.878.368 1.496v13.5a1.5 1.5 0 0 0 3 0z" />
  </svg>
);
const ForwardRef = forwardRef(IconRestaurantFilledSVG);
ForwardRef.displayName = "IconRestaurantFilled";
export { ForwardRef as IconRestaurantFilled };
